export default "__VITE_ASSET__BCqY6q7l__"